import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import 'currency-flags/dist/currency-flags.min.css'

import WOW from 'wow.js'

new WOW().init()

Vue.use(Vuetify)

function load (layout) {
  return () => import(`layout/${layout}`)
}

Vue.component('home-layout', load('home'))
Vue.component('admin-layout', load('admin'))


// WEBPACK FOOTER //
// ./src/bootstrap.js